import Loading from "component/layout/loading/spinner/Loading";
import { action, observable, toJS } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { Props } from "wasabi-common";

import NetworkUnreachable from "./view/NetworkUnreachable";
import NotFound from "./view/NotFound";

export interface AsyncComponentState extends Props<any> {
  Component?: any;
}

export interface AsyncComponentProps extends Props<any> {
  LoadingComponent?: React.ComponentType;
}

export class AsyncComponentStore {
  @observable
  private _Component: any;
  @observable
  private _props: Props<any>;

  public get Component(): any {
    return this._Component;
  }

  public get props(): Props<any> {
    return this._props;
  }

  @action
  public set(Component: any, props: Props<any>) {
    this._Component = Component;
    this._props = props;
  }
}

export default function asyncComponent(getComponent: Function, externalProps?: AsyncComponentProps) {
  const store = new AsyncComponentStore();
  const staticProps = externalProps || {};
  const { LoadingComponent, ...componentProps } = staticProps;

  return observer(
    class AsyncComponent extends React.Component<Props<any>, AsyncComponentState> {
      public constructor(props: Props<any>) {
        super(props);
      }

      async componentDidMount() {
        try {
          // const lang = await loadLanguage(staticProps);
          const Component: any = await getComponent();
          store.set(Component, {
            ...componentProps,
          });
        } catch (e) {
          console.error(e);
          switch (e.code) {
            case "NETWORK_UNREACHABLE":
              store.set(NetworkUnreachable, {});
              break;
            default:
              store.set(NotFound, {});
          }
        }
      }

      render() {
        const { Component, props } = store;
        if (Component) {
          return <Component {...this.props} {...toJS(props)} />;
        }
        return LoadingComponent ? <LoadingComponent /> : <Loading />;
      }
    }
  );
}
